import axios from "@/axios";

const endpoint = "/financials";

const Financials = {
    calculate: async (businessId, payload) => {
        return axios
        .post(`${endpoint}/business/${businessId}`, payload)
        .then((response) => {
            const data = response.businessFinancials.inputs
            
            return {
              revenue: data.revenue,
              costOfGoodsSold: data.costOfGoodsSold,
              netIncome: data.netIncome,
              operatingIncome: data.operatingIncome,
              currentAssets: data.currentAssets,
              currentLiabilities: data.currentLiabilities,
              totalLiabilities: data.totalLiabilities,
              totalAssets: data.totalAssets,
              otherAssets: data.otherAssets,
              totalPersonalLiabilities: data.totalPersonalLiabilities,
              totalPersonalAssets: data.totalPersonalAssets,
              loanAmount: data.loanAmount
            };
          })
        .catch((error) => {
            console.log(error);
            return {
                revenue: '',
                costOfGoodsSold: '',
                netIncome: '',
                operatingIncome: '',
                currentAssets: '',
                currentLiabilities: '',
                totalLiabilities: '',
                totalAssets: '',
                otherAssets: '',
                totalPersonalLiabilities: '',
                totalPersonalAssets: '',
                loanAmount: ''
            }
        })

    }
};

export default Financials;